import cx from "classnames";
import React from "react";

import { Interpolate } from "@/mk2/components/Interpolate";
import {
    BLOCKED_BAZAAR,
    BLOCKED_BAZAAR_OF_USER,
    BLOCKED_BAZAAR_OF_USER_EXPLANATION,
    PROFILE_username_BLOCKED_BY_USER,
    YOUR_BAZAAR_WAS_SUSPENDED_EXPLANATION,
} from "@/mk/autogenerated/translation";

import styles from "./BlockedBazaarMessage.mscss";

interface OwnProps {
    className?: string;
    isSeller: boolean;
    selfBlocked: boolean;
    username: string;
}

type Props = OwnProps;

const BlockedBazaarMessage: React.FunctionComponent<Props> = ({
    className,
    isSeller,
    selfBlocked,
    username,
}) => (
    <div className={cx(styles.BlockedBazaarMessage, className)}>
        <div className={styles.BlockedBazaarMessage__heading}>
            {selfBlocked ? (
                <Interpolate
                    i18nKey={PROFILE_username_BLOCKED_BY_USER}
                    username={<strong>{username}</strong>}
                />
            ) : isSeller ? (
                BLOCKED_BAZAAR
            ) : (
                BLOCKED_BAZAAR_OF_USER
            )}
        </div>
        {!selfBlocked && (
            <div className={styles.BlockedBazaarMessage__explanation}>
                {isSeller
                    ? YOUR_BAZAAR_WAS_SUSPENDED_EXPLANATION
                    : BLOCKED_BAZAAR_OF_USER_EXPLANATION}
            </div>
        )}
    </div>
);

BlockedBazaarMessage.displayName = "BlockedBazaarMessage";

export default React.memo<Props>(BlockedBazaarMessage);
